module.exports = __webpack_public_path__ + "static/media/C_K.9c20f624.png";